export const MARKETS = {
  ALIEXPRESS: 'aliExpress',
  EBAY: 'ebay',
  AMAZON: 'amazon',
  WALMART: 'walmart',
};

export const ESTIMATIONS = {
  BASIC: 604800,
  LISTING: 172800,
};

export const animationTime = 500;

export const discoveryFetchesCount = 50;
export const discoveryFetchesTimeout = 60000;
